/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { GAME_TYPE } from '@game-type/game-market-types'
import { PAGE_TYPE } from '@interface/common'
import PreMatchPage from '@views/Matchup/MatchField/PreMatchPage'
// import SpecialMatch from '@views/Matchup/MatchField/SpecialMatchPage'
import useRootStore from '@store/useRootStore'
import { CLUB_MEMBER_STATE } from 'adv-protocol/src/GameCommon'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { Content } from '@styles/base.style'
import { CLUB_JOIN_STATE } from '@constants/index'
import _ from 'lodash'
import { TournamentTrack } from '@store/matchupStore'

interface MatchUpListProps {
  pageType?: PAGE_TYPE
  tracks?: TournamentTrack[]
}

const MatchUpList: React.FC<MatchUpListProps> = (props: MatchUpListProps) => {
  const { matchupStore, globalStore, authStore, componentStore, popularSearchTermStore } = useRootStore()
  const { matchupNotices } = componentStore
  const { popularSearchTerms } = popularSearchTermStore
  const { currentGameKey, /* currentSportsKey, majorUniqueID, */ club = {} } = matchupStore
  const { memberState, isMember, name, clubJoinState, id: clubId, ownerId } = club
  const { isSignedIn } = authStore
  const { pageType, tracks } = props
  const gameKey = (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER)
    ? GAME_TYPE.CROSS : currentGameKey

  const onClickJoinClub = () => {
    if (memberState === CLUB_MEMBER_STATE.SEEK_MEMBER || clubJoinState === CLUB_JOIN_STATE.DENY) {
      return
    }

    matchupStore.joinClub(clubId, ownerId)
  }

  const showMemberStateMessage = (visibleJoinMessage?: boolean) => {
    if (!isMember) {
      if (memberState === CLUB_MEMBER_STATE.SEEK_MEMBER) {
        showToast(TOAST_TYPE.INFO, `${name} 클럽 가입 대기 상태입니다.`)
      } else if (clubJoinState === CLUB_JOIN_STATE.DENY) {
        showToast(TOAST_TYPE.INFO, `${name} 클럽 가입 거부 상태입니다.`)
      } else if (visibleJoinMessage) {
        globalStore.pushDialogYesNo({
          title: name,
          text: ['클럽 미가입 상태에서는 베팅할 수 없습니다.', '무료 가입하시겠습니까?'],
          className: 'small-size',
          positivePress: '클럽무료가입',
          negativePress: '취소',
          callbackPositive: onClickJoinClub,
        })
      }
    }
  }

  const onFieldClickCheck = (): boolean => {
    if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      return true
    }

    if (isSignedIn) {
      showMemberStateMessage(true)
      return isMember
    }
    return true
  }

// const contentProps = {
  //   gameKey,
  //   currentSportsKey,
  //   majorUniqueID,
  //   gameKey: gameKey,
  //   onFieldClickCheck,
  // }

  let visibleTopNoticeClass = ''
  if (_.size(matchupNotices) > 0) {
    visibleTopNoticeClass = 'visible-top-notice'
  }

  let visiblePopularSearchTermClass = ''
  if (_.size(popularSearchTerms) > 0) {
    visiblePopularSearchTermClass = 'visible-popular-search-term'
  }

  const viewKey = `MatchUpList:MatchPage:${gameKey}`
  let contentClassName: string
  const pageOrGameKeyClassName = pageType === PAGE_TYPE.MATCHUP || pageType == null ? gameKey : pageType
  if (!authStore.isSignedIn) {
    if (isMobile) {
      contentClassName = `match-list guest-list ${pageOrGameKeyClassName}`
    } else {
      contentClassName = `match-list guest-list pc ${pageOrGameKeyClassName} ${visiblePopularSearchTermClass}`
    }
  } else {
    if (isMobile) {
      contentClassName = `match-list ${pageOrGameKeyClassName}`
    } else {
      contentClassName = `match-list pc ${pageOrGameKeyClassName} ${visibleTopNoticeClass} ${visiblePopularSearchTermClass}`
    }
  }

  if (gameKey === GAME_TYPE.CROSS || gameKey === GAME_TYPE.WAY || gameKey === GAME_TYPE.UO
    || gameKey === GAME_TYPE.LIVE || gameKey === GAME_TYPE.SPECIAL) {
    return (
        <Content className={contentClassName}>
          <PreMatchPage key={viewKey} onFieldClickCheck={onFieldClickCheck} pageType={pageType} tracks={tracks}/>
        </Content>
      )
  }
  return null
}

export default observer(MatchUpList)
